<template>
  <div>
    <div class="row">
      <div class="login-form-col">
        <div class="container login-form mx-auto">
          <img src=".././assets/images/Logo.svg" alt="">
          <form class="form-set" @submit.prevent="handleSubmit">
            <div class="form-container">
              <p style="color:red" v-text="error"></p>
              <div class="form-group">
                <label for="username">Email</label>
                <input type="email" class="form-control" placeholder="Enter email" v-model="email">
              </div>
              <a href="mailto:support@konnect-us.com">Contact support</a>
            </div>
            <button type="submit" class="btn btn-primary btn-login">Reset password</button>
          </form>
        </div>
      </div>
      <div class="col-7">
        <img src=".././assets/images/img1@2x-no-bg-5.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ResetPassword',
    data() {
      return {
        email: '',
      };
    },
    computed: {
      error() {
        return this.$store.state.auth.error;
      },
    },
    methods: {
      handleSubmit() {
        this.$store.dispatch('auth/resetPassword', { email: this.email })
          .then(() => this.$snotify.success('Reset password email sent'))
          .catch(() => this.$snotify.error(this.error));
      },
    },
  };
</script>

<style scoped>
  .col-7 {
    z-index: 0;
  }
  .col-5 {
    z-index: 1;
  }
</style>
